import React from "react";

export function IconSlider() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.33333 10.833C3.79357 10.833 4.16667 11.2061 4.16667 11.6663V17.4997C4.16667 17.9599 3.79357 18.333 3.33333 18.333C2.8731 18.333 2.5 17.9599 2.5 17.4997V11.6663C2.5 11.2061 2.8731 10.833 3.33333 10.833Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.33333 1.66699C3.79357 1.66699 4.16667 2.04009 4.16667 2.50033V8.33366C4.16667 8.7939 3.79357 9.16699 3.33333 9.16699C2.8731 9.16699 2.5 8.7939 2.5 8.33366V2.50033C2.5 2.04009 2.8731 1.66699 3.33333 1.66699Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0013 9.16699C10.4615 9.16699 10.8346 9.54009 10.8346 10.0003V17.5003C10.8346 17.9606 10.4615 18.3337 10.0013 18.3337C9.54106 18.3337 9.16797 17.9606 9.16797 17.5003V10.0003C9.16797 9.54009 9.54106 9.16699 10.0013 9.16699Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0013 1.66699C10.4615 1.66699 10.8346 2.04009 10.8346 2.50033V6.66699C10.8346 7.12723 10.4615 7.50033 10.0013 7.50033C9.54106 7.50033 9.16797 7.12723 9.16797 6.66699V2.50033C9.16797 2.04009 9.54106 1.66699 10.0013 1.66699Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6654 12.5C17.1256 12.5 17.4987 12.8731 17.4987 13.3333V17.5C17.4987 17.9602 17.1256 18.3333 16.6654 18.3333C16.2051 18.3333 15.832 17.9602 15.832 17.5V13.3333C15.832 12.8731 16.2051 12.5 16.6654 12.5Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6654 1.66699C17.1256 1.66699 17.4987 2.04009 17.4987 2.50033V10.0003C17.4987 10.4606 17.1256 10.8337 16.6654 10.8337C16.2051 10.8337 15.832 10.4606 15.832 10.0003V2.50033C15.832 2.04009 16.2051 1.66699 16.6654 1.66699Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 11.6663C0 11.2061 0.373096 10.833 0.833333 10.833H5.83333C6.29357 10.833 6.66667 11.2061 6.66667 11.6663C6.66667 12.1266 6.29357 12.4997 5.83333 12.4997H0.833333C0.373096 12.4997 0 12.1266 0 11.6663Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66797 6.66634C6.66797 6.2061 7.04106 5.83301 7.5013 5.83301H12.5013C12.9615 5.83301 13.3346 6.2061 13.3346 6.66634C13.3346 7.12658 12.9615 7.49967 12.5013 7.49967H7.5013C7.04106 7.49967 6.66797 7.12658 6.66797 6.66634Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.332 13.3333C13.332 12.8731 13.7051 12.5 14.1654 12.5H19.1654C19.6256 12.5 19.9987 12.8731 19.9987 13.3333C19.9987 13.7936 19.6256 14.1667 19.1654 14.1667H14.1654C13.7051 14.1667 13.332 13.7936 13.332 13.3333Z"
        fill="white"
      />
    </svg>
  );
}
